import { Alert, AlertProps } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import BrandName from "components/Shared/BrandName";
import ContactEmailLink from "components/Shared/ContactEmailLink";
import { useBrandQuery } from "utils/apollo/hooks/brand";
import { useCurrentBrandData } from "utils/currentUserHooks";

const textFragment = gql(/* GraphQL */ `
  fragment ParentBrandText on Brand {
    id
    parentName
  }
`);

const query = gql(/* GraphQL */ `
  query ParentBrandAlert($id: UUID!) {
    brand(id: $id) {
      id
      parentId
      parent {
        id
        name
      }
      ...ParentBrandText
    }
  }
`);

type ParentBrandTextProps = {
  brand: FragmentType<typeof textFragment>;
};

export function ParentBrandText({
  brand: brandFragment,
}: ParentBrandTextProps) {
  const brand = getFragmentData(textFragment, brandFragment);
  return (
    <>
      <BrandName fontWeight="bold" /> has been configured as child of{" "}
      {brand.parentName ? <b>{brand.parentName}</b> : "another brand"}. The
      parent brand and its users have access to and control over this brand. For
      more information or to change this configuration, please contact{" "}
      <ContactEmailLink />.
    </>
  );
}

export default function ParentBrandAlert(props: AlertProps) {
  const brand = useCurrentBrandData();

  const { data } = useBrandQuery(query, {
    skip: !brand?.parentId,
    variables: brand ? { id: brand.id } : undefined,
  });

  if (!brand?.parentId || !data?.brand) return null;

  return (
    <Alert display="block" lineHeight="normal" {...props}>
      <ParentBrandText brand={data?.brand} />
    </Alert>
  );
}
